export const routesMesaiYonetici = [
  {
    path: "/mesai_yonetici",
    name: "mesai_yonetici",
    component: () => import("@/views/mesai/mesai_yonetici/index.vue"),
    meta: {
      public: false,
      title: "mesai.Mesai",
      yetki: { k: [1012102] },
    },
  },
]
